import { omniAtom } from "src/utils/atoms";

export interface SimulationContext {
  simulationId: number;
  name: string;
  categoryCode: string;
  reviewType: "Major" | "Minor";
  geoLevel: string;
  geoDetail: string | null;
}

export const simulationContextAtom = omniAtom({
  value: null as SimulationContext | null,
  key: "assortmentSimulation/simulationContext",
});
